import React from "react";

export const HeaderComponent = (props) =>
    <div className="header-component">
        <div className="header-title">{props.header}</div>
        <div className="header-secondary-title">{props.subHeader}</div>
        <div className="header-sub-text">{props.subText}</div>
    </div>;



// WEBPACK FOOTER //
// ./src/widgets/Common/HeaderComponent.js